import dayjs from "dayjs";
import { ProductKey } from "src/config/config";
import { IssueAppType } from "src/service/types/pay.type";
import * as yup from "yup";

// 제품별 확장 타입 정의
interface BaseFormData {
  companyName: string;
  startDate: string;
  endDate: string;
  licenseCount: number;
  product: string;
  purpose: string;
  telNumber: string;
  userName: string;
  confirmPolicy: boolean;
  issueAppList?: IssueAppType[];
}

interface DspExtensions {
  packageName: string;
}

interface WrapsodyEcoExtensions {
  externalLicenseCount: number;
}

// 조건부 타입 생성
export type FormValuesByProduct<T extends string> = BaseFormData &
  (T extends "DSP" ? DspExtensions : object) &
  (T extends "WRAPSODY_ECO" ? WrapsodyEcoExtensions : object);

const baseSchema = {
  product: yup.string().required(), // 제품명(표기 X)
  userName: yup // 담당자 이름
    .string()
    .required("logIn.enterName") // 이름을 입력해주세요
    .max(50, "siteType.free.detail.alertMsg1"), // 50자까지 입력할 수 있습니다
  telNumber: yup.string().required("siteType.free.detail.alertMsg5"), // 담당자 연락처
  companyName: yup.string().required("admin.common.alert.check.enterCompany"), // 회사명
  purpose: yup.string().notRequired(), // 사용 목적

  // 요금제 세부 정보 - licenseCount는 제품별로 다르게 설정
  startDate: yup.string().notRequired(), // 시작일
  endDate: yup.string().notRequired(), // 종료일
};
// 🧩 Yup 스키마 정의
export const askPromotionSchema = (product: ProductKey) => {
  const isDspProduct = product === "DSP";
  const isDspmProduct = product === "DSPM";
  const isWrapsodyEco = product === "WRAPSODY_ECO";
  const isWrapsody = product === "WRAPSODY";
  const isFiresideProduct = product === "FIRESIDE";
  const defaultValues: any = {
    product,
    // licenseCount: 10,
    packageName: "",
    startDate: dayjs().format("YYYY-MM-DD"), // "2024-01-01", // ISO 8601 형식 문자열
    endDate: dayjs().add(1, "year").format("YYYY-MM-DD"), // "2024-01-31",
  };
  if (isWrapsody || isWrapsodyEco || isFiresideProduct) {
    defaultValues.userPerStorage = 100;
  }
  if (!isDspmProduct) {
    defaultValues.licenseCount = 10;
  }
  // if (isDspProduct) {
  //   defaultValues.packageName = "DOCUMENT_SECURITY";
  // }
  if (isWrapsodyEco) {
    defaultValues.externalLicenseCount = 10;
  }
  // 기본 스키마 - licenseCount를 제품별로 다르게 설정
  let schema = yup.object({
    ...baseSchema,
    // DSPM 제품일 때는 licenseCount 필수값 아님, 다른 제품은 필수값
    licenseCount: isDspmProduct
      ? yup.number().typeError("").notRequired()
      : yup.number().typeError("").required(),
    userPerStorage: yup.number().typeError("").optional(),
    confirmPolicy: yup
      .boolean()
      .oneOf([true], "logIn.signUp.agreement")
      .required(),
    issueAppList: yup
      .array()
      .of(
        yup.object({
          id: yup.string().required(),
          name: yup.string().required(),
        })
      )
      .notRequired(),
  });
  if (isWrapsodyEco) {
    schema = schema.shape({
      externalLicenseCount: yup.number().typeError("").required(),
    });
  } else {
    schema = schema.shape({
      externalLicenseCount: yup.number().notRequired(),
    });
  }

  return { schema, defaultValues };
};
